import { DownloadPracticeContractPdfArgs, DownloadPracticeContractPdfResponse } from '@hb/shared'
import { downloadPracticeContractPdf } from '../backend/practiceContracts/utils'

// Triggers a browser download of a practice contract PDF (signed or unsigned).
// Mirrors downloadConsentForm.
export const downloadPracticeContract = async (practiceContractId: string, practiceId: string) => {
  const args: DownloadPracticeContractPdfArgs = { practiceId, practiceContractId }
  const { data } = await downloadPracticeContractPdf(args)
  const response = data as DownloadPracticeContractPdfResponse | undefined
  if (response?.signedUrl && response?.fileName) {
    const pdfResponse = await fetch(response.signedUrl)
    const blob = await pdfResponse.blob()
    const blobUrl = window.URL.createObjectURL(blob)

    const link = window.document.createElement('a')
    link.href = blobUrl
    link.download = response.fileName
    window.document.body.appendChild(link)
    link.click()
    window.document.body.removeChild(link)

    window.URL.revokeObjectURL(blobUrl)
  } else {
    throw new Error('Invalid response from server')
  }
}
